import { enqueueSnackbar } from "notistack";
import { searchChats, searchMessages } from "../api";
import { useSearchStore } from "../model";

export const handleSearch = async (query: string, initial = true) => {
  const {
    setChats,
    setMessages,
    setPageChats, setPageMessages,
    setHasMoreChats, setHasMoreMessages,
    setLoadingMore,
  } = useSearchStore.getState();

  try {
    setLoadingMore(true);
    const chatPage = initial ? 1 : useSearchStore.getState().pageChats;
    const resChats = await searchChats({ query, page: chatPage });

    if (resChats.success) {
      const chats = resChats.result ?? [];
      setChats(initial ? chats : [...useSearchStore.getState().chats, ...chats]);
      setPageChats(chatPage + 1);

      const hasMoreChats = chats.length >= 30;
      setHasMoreChats(hasMoreChats);

      // if (!hasMoreChats) {
      //   const msgPage = initial ? 1 : useSearchStore.getState().pageMessages;
      //   const resMessages = await searchMessages({chatId, query, page: msgPage });
      //   if (resMessages.success) {
      //     const msgs = resMessages.result ?? [];
      //     setMessages(initial ? msgs : [...useSearchStore.getState().messages, ...msgs]);
      //     setPageMessages(msgPage + 1);
      //     setHasMoreMessages(msgs.length >= 30);
      //   }
      // }
    }
  } catch (e) {
    console.error(e);
    enqueueSnackbar("Ошибка при поиске", { variant: "error" });
  } finally {
    setLoadingMore(false);
  }
};
